export enum MerchantPaymentTypes {
  Paid = 1,
  //,Freemium = 2
}
